// Pick a legible foreground (charcoal vs cream) for a given background color.
// Threshold L > 0.35 keeps cream glyphs on every category palette entry.
// Yellow and sky were darkened in primitives.css so cream-on-color passes
// WCAG AA non-text (3:1) for the entire palette — see contrast.test.ts for
// per-category guards.

import { CHARCOAL, CREAM } from '../theme/colors';
export { CHARCOAL, CREAM };

export function legibleOn(bgHex: string | undefined | null): string {
  if (!bgHex || bgHex[0] !== '#' || bgHex.length < 7) return CHARCOAL;
  const r = parseInt(bgHex.slice(1, 3), 16) / 255;
  const g = parseInt(bgHex.slice(3, 5), 16) / 255;
  const b = parseInt(bgHex.slice(5, 7), 16) / 255;
  const lin = (v: number) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
  const L = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  return L > 0.35 ? CHARCOAL : CREAM;
}
